"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FetchPolicy", {
  enumerable: true,
  get: function get() {
    return _useResource2.FetchPolicy;
  }
});
Object.defineProperty(exports, "NetworkStatus", {
  enumerable: true,
  get: function get() {
    return _useResource2.NetworkStatus;
  }
});
Object.defineProperty(exports, "Sorting", {
  enumerable: true,
  get: function get() {
    return _useResource2.Sorting;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "useResource", {
  enumerable: true,
  get: function get() {
    return _useResource2.useResource;
  }
});

var _react = _interopRequireDefault(require("react"));

var _useResource2 = require("./useResource");

var _excluded = ["children", "notifyOnNetworkStatusChange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayDataProvider = function ClayDataProvider(_ref) {
  var children = _ref.children,
      _ref$notifyOnNetworkS = _ref.notifyOnNetworkStatusChange,
      notifyOnNetworkStatusChange = _ref$notifyOnNetworkS === void 0 ? false : _ref$notifyOnNetworkS,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  /**
   * networkStatus is only updated when notifyOnNetworkStatusChange
   * is enabled, this will inform of the fetch status and cause
   * a new rendering.
   */
  var _React$useState = _react.default.useState(function () {
    return {
      error: false,
      loading: false
    };
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var handleNetworkStatus = function handleNetworkStatus(status) {
    var payload = {
      error: status === 5,
      loading: status < 4
    };

    if (notifyOnNetworkStatusChange) {
      payload.networkStatus = status;
    }

    setState(payload);
  };

  var _useResource = (0, _useResource2.useResource)(_objectSpread(_objectSpread({}, otherProps), {}, {
    onNetworkStatusChange: handleNetworkStatus
  })),
      refetch = _useResource.refetch,
      resource = _useResource.resource; // Adding a fragment is a hack to dribble the
  // react-docgen to identify that it is a component.


  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children(_objectSpread(_objectSpread({}, state), {}, {
    data: resource,
    refetch: refetch
  })));
};

var _default = ClayDataProvider;
exports.default = _default;